module.exports = __webpack_public_path__ + "img/network-traffic-analysis.567df0e5.jpg";